module.exports = __webpack_public_path__ + "img/sleep.795ee0a6.svg";